import request from '../../utils/request';

// 新增一级分类
export function addFirstType(params,authorization){
  return request({
    url: '/api/sensitive/consult/addSensitiveWordType',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}
// 新增词库
export function addConsultStore(params,authorization){
  return request({
    url: '/api/sensitive/consult/addconsultclass',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}

/*** 删除词库 旧版 */
export function delConsultStore(params,authorization){
  return request({
    url: `/api/sensitive/consult/delconsultclass/${params}`,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}

/** 关键词分类删除 新版*/
export function deleteRuleApi(params,authorization){
  return request({
    url: `/api/qywechat/deleteRule`,
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}



// 删除一级分类
export function delFirstType(params,authorization){
    return request({
      url: `/api/sensitive/consult/delSensitiveWordType/${params}`,
      method: 'delete',
      headers: {
        "authorization": authorization
      }
    })
  }

  // 编辑一级分类
export function editFirstType(id,params,authorization){
    return request({
      url: `/api/sensitive/consult/updateSensitiveWordType/${id}`,
      method: 'POST',
      data: params,
      headers: {
        "authorization": authorization
      }
    })
  }
  
  /** 修改词库 旧版 */
  export function editWordType(id,params,authorization){
    return request({
      url: `/api/sensitive/consult/updateconsultclass/${id}`,
      method: 'POST',
      data: params,
      headers: {
        "authorization": authorization
      }
    })
  }

  /** 关键词修改 新版 */
    export function updateRuleApi(params,authorization){
    return request({
      url: `/api/qywechat/updateRule`,
      method: 'PUT',
      data: params,
      headers: {
        "authorization": authorization
      }
    })
  }

    // 查询所有一级分类(获取词库列表 旧版)
export function getFirstTypeList(authorization){
    return request({
      
      url: `/api/sensitive/consult//getsensitiveconslutclassList`,
      method: 'get',
      headers: {
        "authorization": authorization
      }
    })
}

/** 获取词库列表 新版 */
export function ruleTypeListApi(authorization){
      return request({
        url: `/api/qywechat/ruleTypeList`,
        method: 'get',
        headers: {
          "authorization": authorization
        }
    })
}

// 获取单个分类
export function getTypeList(params, authorization){
  return request({
    url: `/api/sensitive/consult/getSensitiveWordTypeList/${params}`,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}

// 新增二级分类
export function addTwoType(params,authorization){
    return request({
      url: '/api/qywechat/script/two_class',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    })
  }
  // 删除二级分类
  export function delTwoType(params,authorization){
      return request({
        url: `/api/qywechat/script/two_class/${params}`,
        method: 'delete',
        headers: {
          "authorization": authorization
        }
      })
    }
  
    // 编辑二级分类
  export function editTwoType(id,params,authorization){
      return request({
        url: `/api/qywechat/script/two_class/${id}`,
        method: 'put',
        data: params,
        headers: {
          "authorization": authorization
        }
      })
    }
        // 查询一级分类下的二级分类
export function getTowTypeList(params,authorization){
    return request({
      url: `/api/qywechat/script/two_class/${params}`,
      method: 'get',
      headers: {
        "authorization": authorization
      }
    })
}
// 获取关键词列表 旧版
export function getConsultList(params,authorization){
    return request({
      url: `/api/sensitive/consult//getSensitiveWordList`,
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    })
}

/**  获取关键词列表 新版 */
export function ruleListApi(params,authorization){
  return request({
    url: `/api/qywechat/ruleList`,
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}

/**  获取词库列表搜索 新版(只用于搜索！！！) */
export function ruleListSearchApi(params,authorization){
  return request({
    url: `/api/qywechat/ruleListSearch?keyword=${params}`,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}


// 删除关键词
export function delConsult(params,authorization){
    return request({
      url: `/api/sensitive/consult/delSensitiveWord/${params}`,
      method: 'delete',
      headers: {
        "authorization": authorization
      }
    })
}
// 添加关键词 (旧版)
export function addSensitiveWord(params,authorization){
  return request({
    url: `/api/sensitive/consult/addSensitiveWord`,
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}

// 添加关键词 (新版)
export function createRuleApi(params,authorization){
  return request({
    url: `/api/qywechat/createRule`,
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  })
}

/** 文件导入 关键词导入旧版 */
export function importData(data,authorization, isloading= true){
  return request({
    url: `/api/sensitive/consult/importData`,
    method: 'post',
    data,
    headers: {
      "authorization": authorization,
      "Content-Type": "multipart/form-data",
    }
  },isloading)
}

/** 关键词导入 新版 */
export function importDataApi(data,authorization, isloading= true){
  return request({
    url: `/api/qywechat/msg/importData`,
    method: 'post',
    data,
    headers: {
      "authorization": authorization,
      "Content-Type": "multipart/form-data",
    }
  },isloading)
}

// 同步院内项目
export function asyncItem(authorization, isloading= true){
  return request({
    url: `/api/sensitive/consult/import`,
    method: 'get',
    headers: {
      "authorization": authorization,
    }
  },isloading)
}






 

  





